//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Epk.WebControls.GEpkPreActions.ts                    </Name>
//    <Description>                                                             </Description>
//    <Author>      TFeik                                                       </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2020                            </Copyright>
//    <Created>     2020-04-27                                                  </Created>
//  </FileHeader>

namespace Gordic.Epk.PreActions {
    /**
     * PreActionNames
     * 
     * @author TFeik
     * @since 484.1.0.43
     */
    export enum Names {
        OtevriDetailZadosti = 'actOtevriDetailZadosti'
    }

    /**
     * Otevře detail žádosti.
     *
     * @author  TFeik
     * @date    27.04.2020
     * 
     * @param {Gordic.Prefabs.Actions.BasePreActionsInput<Gordic.Gui.Dialogs.OpenDialogParams<WebControls.GEpkDetailDlgInputParams>} input
     * @returns {GActionParams}
     */
    export function OtevriDetailZadosti(
        input: Gordic.Prefabs.Actions.BasePreActionsInput<Gordic.Gui.Dialogs.OpenDialogParams<Epk.WebControls.GEpkDetailDlgInputParams>, /*WebControls.GEpkDetailDlgReturnValue*/boolean>
    ): GActionParams {
        return Gordic.Prefabs.Actions.buildActionPrefab(
            input,
            Gordic.Prefabs.Icons.IconToActionParams(Gin.Globals.Icons.ZobrazitDetail()),
            {
                name: Names.OtevriDetailZadosti,
                caption: 'jres:32000549', //RC 32000549 : Otevřít žádost
                tooltip: 'jres:32000550', //RC 32000550 : Otevřít detail žádosti o podpis.
                run: function (ev, ctx) {
                    ctx.content.beginOperation();
                    return Dialogs.DetailZadostiDlg(
                        ctx.content,
                        ctx.inputData.opt,
                        ctx.inputData.ModOtevreni
                    )
                        .always(function () {
                            ctx.content.endOperation();
                        });
                }
            }
        );
    }
}